import { type ReduxStoreState, type Survey, useSurveyContext } from '@confer/lib'
import { Button } from 'antd'
import { useSelector } from 'react-redux'

export type CompletionReviewSurvey = Survey & {
  settings: Survey['settings'] & { allowPreviousAfterSubmit?: boolean }
}

const CompletionNavigation = () => {
  const { survey, currentQuestion, previousQuestion, interactionDisabled, displayBackButton } =
    useSurveyContext()
  const submitted = useSelector(({ survey }: ReduxStoreState) => survey.isSubmitClicked)
  const { allowPreviousAfterSubmit } = (survey as CompletionReviewSurvey).settings

  if (
    !allowPreviousAfterSubmit ||
    !submitted ||
    currentQuestion?.type !== 'endPage' ||
    !displayBackButton()
  ) {
    return null
  }

  return (
    <Button size="large" onClick={previousQuestion} disabled={interactionDisabled}>
      Previous
    </Button>
  )
}

export default CompletionNavigation
